import script from "./GetTeamId.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetTeamId.vue?vue&type=script&setup=true&lang=ts"

import "./GetTeamId.vue?vue&type=style&index=0&id=27c059f5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c059f5"]])

export default __exports__